<script setup lang="ts">
import {onMounted, ref} from "vue";
import {laboratoryApi} from "@/container";
import Dashboard from "@/laboratory/components/dashboard/components/Dashboard.vue";

const props = defineProps<{
    laboratoryId: string;
}>();

const data = ref();

onMounted(() => {
    laboratoryApi().dashboard(props.laboratoryId)
        .then((response) => {
            data.value = response;
        });
});
</script>

<template>
  <Dashboard v-if="data" :dashboard="data" :laboratory-id="laboratoryId" />
</template>

<style scoped>

</style>
